import type { ReactNode } from 'react';

/** 페이지 제목 줄 — 제목 24 Bold + 보조 13, 우측 액션 */
export const PageHeader = ({
  title,
  description,
  actions,
}: {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}) => (
  <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
    <div className="flex flex-col gap-1">
      <h1 className="text-xl leading-8 font-bold text-ink lg:text-2xl lg:leading-9">
        {title}
      </h1>
      {description && (
        <p className="text-[13px] leading-5 text-ink-4">{description}</p>
      )}
    </div>
    {actions && (
      <div className="flex flex-wrap gap-2.5 lg:ml-auto">{actions}</div>
    )}
  </div>
);
